<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from '../groups/List'
import Editor from '../groups/Editor'
import BottomSheet from '../BottomSheet'
export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/settings/groups/list'
    },
    {
      path: "new",
      name: "New group",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Edit group"
      }
    },
    {
      path: "edit/:id",
      name: "Edit group",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      }
    },
    {
      path: "list",
      name: "Group list",
      component: List
    }
  ],
}
</script>
